import React, {Component} from 'react'
import {Documents} from './Documents'
import styles from './styles'
import {Typography} from 'components/OptimisedMui'
import {InfoDialog} from 'components/InfoDialog'
import {Markdown} from 'components/Markdown'
import {TextField, LinkButton} from 'components'

export class Aml extends Component {
  static defaultProps = {
    title: 'Enhanced Due Diligence',
    name: 'ECDD'
  }

  state = {}

  handleShowAmlInfo = () => {
    this.setState({showAmlInfo: true})
  }

  handleCloseAmlInfo = () => {
    this.setState({showAmlInfo: false})
  }

  render = () =>
    <Documents {...this.props} tag="aml">
      <div className={styles.section}>
        <Typography paragraph={true}>
          As part of our customer due diligence process, you have been selected for enhanced customer due diligence. As
          such, we need you to <strong>provide source of funds and source of wealth</strong> information and
          documentation.
        </Typography>
        <Typography paragraph={true}>
          <strong>Source of Wealth</strong> is defined as the origin of the customer’s entire body of assets. This
          helps to identify how the customer acquired their wealth and from what sources.
        </Typography>
        <Typography paragraph={true}>
          <strong>Source of Funds</strong> is defined as the origin of the customer’s funds for the specific
          transactions or activities for the business relationship.
        </Typography>
        <Typography variant="body1" paragraph={true}>
          In the text box provided, please indicate the source of funds you will use for your transactions and your
          source of wealth.
        </Typography>
        <TextField member="sourceOfFunds" label="Briefly describe you source of wealth/funds" fullWidth multiline required />
      </div>
      <Typography paragraph={true}>
        Please <strong>attach documentation</strong> supporting your source of funds and source of
        wealth. <LinkButton onClick={this.handleShowAmlInfo}>Click here to see a list of document types</LinkButton> that can be
        provided.
      </Typography>

      <InfoDialog open={this.state.showAmlInfo} onClose={this.handleCloseAmlInfo}>
        <Markdown mdtext={this.props.amlInfo.renderedContent}/>
      </InfoDialog>
    </Documents>
}